import { clone } from 'lodash';

export class Reward {
  id: string;
  created_at: string;
  consumer_id: string;
  name: string;
  status: string;
  timeline: any;
  amount: number;
  comment: string;

  constructor(payload: Object = {}) {
    Object.assign(this, payload);
  }
}

export function toApi(data: any) {
  data = clone(data);

  return data;
}
